'use client'

import { MouseEvent } from 'react'
import { Card, Pagination as PaginationComponent } from '@vinted/web-ui'

import {
  buildCatalogPaginationParams,
  CATALOG_PER_PAGE,
  filterEmptyValues,
} from '@marketplace-web/catalog/catalog-data'
import { useCatalogContext } from '@marketplace-web/catalog/catalog-page-data'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { scrollToTop } from '@marketplace-web/browser/browser-interaction-util'
import { toUrlQuery } from '@marketplace-web/browser/url-util'

import useItemsCatalogQuery from '../../../hooks/useItemsCatalogQuery'
import { CATALOG_URL } from '../../../constants/routes'

const Pagination = () => {
  const breakpoints = useBreakpoint()
  const queryParams = useBrowserNavigation().searchParams
  const {
    state: {
      items: { pagination, error },
    },
  } = useCatalogContext()

  const totalPages = pagination?.total_pages

  const { page: currentPage, time, setQuery } = useItemsCatalogQuery()

  const handlePageSelect = (page: number, event: MouseEvent) => {
    event.preventDefault()

    if (currentPage !== page) {
      scrollToTop()
      setQuery('page', page, 'pushState')
    }
  }

  const urlBuilder = (page: number, perPageOption?: number) => {
    const urlParams = {
      ...queryParams,
      ...buildCatalogPaginationParams({
        page,
        perPage: perPageOption || CATALOG_PER_PAGE,
        time,
      }),
    }

    return `${CATALOG_URL}?${toUrlQuery(filterEmptyValues(urlParams))}`
  }

  if (error || !totalPages || totalPages <= 1) return null

  let paginationStyling: React.ComponentProps<typeof PaginationComponent>['styling'] | undefined

  if (breakpoints.phones) paginationStyling = PaginationComponent.Styling.Narrow

  return (
    <Card>
      <PaginationComponent
        styling={paginationStyling}
        currentPage={currentPage}
        pageCount={totalPages}
        urlBuilder={urlBuilder}
        onPageClick={handlePageSelect}
        onNextClick={handlePageSelect}
        onPrevClick={handlePageSelect}
        testId="catalog-pagination"
      />
    </Card>
  )
}

export default Pagination
